import { natif } from './plateforme';
import { oublierAppareilNatif, ecouterNotificationsNatives } from './push';
import { useState, useEffect } from 'react';
import { isLoggedIn, logout, getCurrentUser, hasRole,
         getMonClub, getToutesEquipes, getEquipePublique,
         getEquipeCourante, setEquipeCourante, urlLogo, getEtatConditions, getAnnoncesNonLues, getVisite } from './api';
import { appliquerTheme } from './theme';
import ClubPage from './pages/ClubPage';
import ConsolePage from './pages/ConsolePage';
import ConditionsPage from './pages/ConditionsPage';
import InscriptionPage from './pages/InscriptionPage';
import DemandeAbonnement from './pages/DemandeAbonnement';
import Nouveautes from './pages/Nouveautes';
import Bientot from './pages/Bientot';
import Aide from './pages/Aide';
import Visite from './pages/Visite';
import SuppressionCompte from './pages/SuppressionCompte';
import { aDesNouveautes } from './nouveautes';
import PublicStats from './pages/PublicStats';
import AdminPanel from './pages/AdminPanel';
import LoginPage from './pages/LoginPage';
import JoueursPage from './pages/JoueursPage';
import PresencesPage from './pages/PresencesPage';
import CaisseNoirePage from './pages/CaisseNoirePage';
import Caisse3mtPage from './pages/Caisse3mtPage';
import CaissesGarde from './pages/CaissesGarde';
import MessagesPage from './pages/MessagesPage';
import TachesPage from './pages/TachesPage';
import MesConvocationsPage from './pages/MesConvocationsPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import { APP_VERSION } from './version';
import { surveillerMaj, appliquerMaj } from './majAuto';
import './App.css';

/**
 * Sélecteur d'équipe.
 * Invisible quand l'utilisateur n'a qu'une équipe. Le super admin voit toutes
 * les équipes de tous les clubs, regroupées par club.
 * Changer d'équipe recharge la page : chaque écran relit ses données.
 */
function SelecteurEquipe({ equipes, courante, superAdmin }) {
  if (!equipes.length || (!superAdmin && equipes.length < 2)) return null;

  const changer = e => {
    setEquipeCourante(parseInt(e.target.value, 10));
    window.location.reload();
  };

  const parClub = equipes.reduce((acc, e) => {
    const k = e.club_nom || '';
    (acc[k] = acc[k] || []).push(e);
    return acc;
  }, {});

  return (
    <select value={courante || ''} onChange={changer} aria-label="Équipe consultée" className="nav-equipe"
      style={{
        background:'#0d1117', color:'#e6edf3', border:'1px solid rgba(255,255,255,.14)',
        borderRadius:8, padding:'7px 8px', fontSize:12, maxWidth:190, cursor:'pointer'
      }}>
      {superAdmin && !courante && <option value="">— Choisir une équipe —</option>}
      {superAdmin
        ? Object.entries(parClub).map(([club, eqs]) => (
            <optgroup key={club} label={club}>
              {eqs.map(e => <option key={e.id} value={e.id}>{e.nom}</option>)}
            </optgroup>))
        : equipes.map(e => <option key={e.id} value={e.id}>{e.nom}</option>)}
    </select>
  );
}

/**
 * Bandeau d'abonnement.
 *   à renouveler   admin du club seulement, discret, masquable
 *   grâce          encadrement, insistant
 *   lecture seule  tout le monde, l'application ne permet plus d'écrire
 */
const frDate = iso => iso ? iso.split('-').reverse().join('/') : '';
function BandeauAbonnement({ abo, role }) {
  const [masque, setMasque] = useState(() => sessionStorage.getItem('abo-masque') === abo?.fin);
  if (!abo) return null;
  const admin = ['admin_club', 'admin'].includes(role);
  const staff = admin || ['coach', 'tresorier', 'admin_3mt'].includes(role);
  const contact = <> Écrivez à <a href="mailto:contact@equipote.fr" style={{ color:'inherit', fontWeight:700 }}>contact@equipote.fr</a>.</>;

  let ton, texte, masquable = false;
  if (abo.statut === 'essai' && staff) {
    const j = abo.restants;
    ton = j <= 3 ? 'alerte' : 'info';
    texte = <>Période d'essai : {j === 0 ? <b>dernier jour</b> : <><b>{j} jour{j > 1 ? 's' : ''}</b> restant{j > 1 ? 's' : ''}</>}
             {j > 0 && <>, jusqu'au {frDate(abo.fin)}</>}.
             {admin && <div style={{ marginTop:8 }}><DemandeAbonnement style={{ padding:'7px 14px', fontSize:12 }} /></div>}</>;
  } else if (abo.statut === 'a_renouveler' && admin && !masque) {
    ton = 'info'; masquable = true;
    texte = <>L'abonnement de votre club se termine le <b>{frDate(abo.fin)}</b>. Pensez à son renouvellement.</>;
  } else if (abo.statut === 'grace' && staff) {
    ton = 'alerte';
    texte = <>L'abonnement de votre club a expiré le <b>{frDate(abo.fin)}</b>. L'application passera en lecture seule
             le <b>{frDate(abo.fin_grace)}</b>.{admin ? contact : ' Prévenez le responsable de votre club.'}</>;
  } else if (abo.statut === 'lecture_seule') {
    ton = 'bloque';
    texte = <>Application en <b>lecture seule</b> : l'abonnement du club a expiré. Vos données restent consultables,
             mais plus modifiables.{admin ? contact : ' Prévenez le responsable de votre club.'}</>;
  } else return null;

  const styles = {
    info:   { bg:'rgba(59,130,246,.10)',  bd:'rgba(59,130,246,.35)',  fg:'#93c5fd', ic:'ℹ️' },
    alerte: { bg:'rgba(249,115,22,.12)',  bd:'rgba(249,115,22,.45)',  fg:'#fdba74', ic:'⏳' },
    bloque: { bg:'rgba(var(--danger-rgb),.12)', bd:'rgba(var(--danger-rgb),.45)', fg:'#fca5a5', ic:'🔒' }
  }[ton];
  return (
    <div role="status" style={{ background:styles.bg, borderBottom:`1px solid ${styles.bd}`, color:styles.fg,
                                padding:'9px 14px', fontSize:12.5, lineHeight:1.5, display:'flex', gap:9, alignItems:'flex-start' }}>
      <span aria-hidden="true">{styles.ic}</span>
      <div style={{ flex:1 }}>{texte}</div>
      {masquable && <button onClick={() => { sessionStorage.setItem('abo-masque', abo.fin); setMasque(true); }}
                            aria-label="Masquer" style={{ background:'none', border:'none', color:'inherit', cursor:'pointer', fontSize:15, lineHeight:1 }}>×</button>}
    </div>
  );
}

/** Écran affiché quand le club est bloqué : suspendu, ou essai terminé. */
function EcranSuspendu({ onDeco, essai, admin }) {
  if (essai) return (
    <div style={{ padding:'60px 24px', maxWidth:440, margin:'0 auto', textAlign:'center' }}>
      <img src="/img/logo-equipote.png" alt="Équipote" style={{ height:42, width:'auto', marginBottom:28 }} />
      <div style={{ fontSize:38, marginBottom:12 }}>⏱️</div>
      <h1 style={{ fontFamily:'Barlow Condensed', fontSize:24, fontWeight:800 }}>La période d'essai est terminée</h1>
      <p style={{ color:'var(--muted)', fontSize:14, lineHeight:1.7, margin:'12px 0 8px' }}>
        Merci d'avoir essayé Équipote. Tout ce que votre équipe a créé pendant l'essai est conservé :
        joueurs, convocations, statistiques, caisses.
      </p>
      <p style={{ color:'var(--muted)', fontSize:14, lineHeight:1.7, margin:'0 0 24px' }}>
        {admin ? <>Pour continuer et tout retrouver, passez à l'abonnement :</>
               : <>Le responsable de votre club peut prolonger l'accès.</>}
      </p>
      {admin && <div style={{ marginBottom:22 }}><DemandeAbonnement /></div>}
      <button className="btn btn-secondary" style={{ width:'auto', padding:'10px 20px' }} onClick={onDeco}>Se déconnecter</button>
    </div>
  );
  return (
    <div style={{ padding:'60px 24px', maxWidth:420, margin:'0 auto', textAlign:'center' }}>
      <img src="/img/logo-equipote.png" alt="Équipote" style={{ height:42, width:'auto', marginBottom:28 }} />
      <div style={{ fontSize:38, marginBottom:12 }}>🔒</div>
      <h1 style={{ fontFamily:'Barlow Condensed', fontSize:24, fontWeight:800 }}>Accès suspendu</h1>
      <p style={{ color:'var(--muted)', fontSize:14, lineHeight:1.7, margin:'12px 0 24px' }}>
        L'accès de votre club à Équipote est momentanément suspendu.
        Contactez le responsable de votre club pour en savoir plus.
      </p>
      <button className="btn btn-secondary" style={{ width:'auto', padding:'10px 20px' }} onClick={onDeco}>Se déconnecter</button>
    </div>
  );
}

function BandeauMaj() {
  const [dispo, setDispo] = useState(false);
  const [enCours, setEnCours] = useState(false);

  useEffect(() => surveillerMaj(() => setDispo(true)), []);

  if (!dispo) return null;

  return (
    <div style={{
      position:'fixed', left:12, right:12, zIndex:3000,
      bottom:`calc(14px + env(safe-area-inset-bottom, 0px))`,
      background:'#161b22', border:'1px solid var(--accent)', borderRadius:12,
      padding:'13px 15px', display:'flex', alignItems:'center', gap:12,
      boxShadow:'0 10px 30px rgba(0,0,0,.45)', maxWidth:520, margin:'0 auto'
    }} role="status" aria-live="polite">
      <span style={{ fontSize:20, flexShrink:0 }} aria-hidden="true">🔄</span>
      <div style={{ flex:1, minWidth:0 }}>
        <div style={{ fontSize:13.5, fontWeight:700, lineHeight:1.3 }}>
          Nouvelle version disponible
        </div>
        <div style={{ fontSize:11.5, color:'#8b949e', marginTop:2 }}>
          Actualisez pour en profiter. Vous restez connecté.
        </div>
      </div>
      <button
        onClick={() => { setEnCours(true); appliquerMaj(); }}
        disabled={enCours}
        style={{
          background:'var(--accent)', border:'none', borderRadius:9, color:'var(--accent-text)',
          fontSize:12.5, fontWeight:700, padding:'10px 16px', cursor:'pointer',
          flexShrink:0, opacity: enCours ? .6 : 1, whiteSpace:'nowrap'
        }}>
        {enCours ? '…' : 'Actualiser'}
      </button>
    </div>
  );
}

function AppliwebFooter({ onConfidentialite, onNouveautes, nouveau, onBientot, onAide }) {
  // Équipote est le produit, Appliweb sa signature : la hiérarchie visuelle le dit.
  return (
    <div className="aw-footer">
      <img src="/img/logo-equipote.png" alt="Équipote" style={{ height:30, width:'auto', display:'block', margin:'0 auto' }} />
      <div style={{ fontSize:11.5, color:'var(--muted)', marginTop:8 }}>
        Toute la vie de votre équipe, au même endroit.
      </div>
      <a href="https://www.appliweb-france.com" target="_blank" rel="noopener noreferrer"
         style={{ display:'inline-flex', alignItems:'center', gap:6, marginTop:14, textDecoration:'none',
                  color:'#5b6370', fontSize:10.5, letterSpacing:.4 }}>
        un produit
        <svg viewBox="0 0 52 52" width="16" height="16" fill="none" aria-hidden="true">
          <circle cx="26" cy="26" r="24" stroke="#5b6370" strokeWidth="3"/>
          <text x="26" y="32" textAnchor="middle" fontFamily="Georgia, serif" fontSize="17" fontWeight="700" fill="#8b949e">AW</text>
        </svg>
        <span style={{ fontWeight:700, color:'#8b949e' }}>appliweb</span>
      </a>
      <div style={{ marginTop:10 }}>
        <button onClick={onConfidentialite} style={{ background:'none', border:'none', color:'#5b6370', fontSize:10.5,
                                                    cursor:'pointer', textDecoration:'underline', padding:0 }}>
          Données personnelles et conditions d'utilisation</button>
      </div>
      <button onClick={onNouveautes} title="Voir les nouveautés"
              style={{ background:'none', border:'none', cursor:'pointer', fontSize:10.5, color:'#5b6370', marginTop:6,
                       letterSpacing:.5, display:'inline-flex', alignItems:'center', gap:6, padding:'2px 4px' }}>
        version {APP_VERSION} · <span style={{ textDecoration:'underline' }}>quoi de neuf ?</span>
        {nouveau && <span style={{ fontSize:9, fontWeight:800, color:'var(--accent-text)', background:'var(--accent)',
                                   borderRadius:4, padding:'1px 6px', letterSpacing:.5 }}>NOUVEAU</span>}
      </button>
      <button onClick={onAide} title="Questions fréquentes et contact"
              style={{ background:'none', border:'none', cursor:'pointer', fontSize:10.5, color:'#5b6370', marginTop:2,
                       letterSpacing:.5, padding:'2px 4px', textDecoration:'underline' }}>aide et contact</button>
      {onBientot && (
        <button onClick={onBientot} title="Les projets à venir"
                style={{ background:'none', border:'none', cursor:'pointer', fontSize:10.5, color:'#5b6370', marginTop:2,
                         letterSpacing:.5, padding:'2px 4px', textDecoration:'underline' }}>bientôt dans Équipote</button>)}
    </div>
  );
}

/**
 * Consigne d'ouverture d'une seule fois, en sessionStorage : « Consulter » dans la console
 * (statistiques), ou la confirmation d'un essai (Mon club). Valable 10 minutes ;
 * effacer = true la consomme. Accepte aussi l'ancien format (texte seul).
 */
const PAGES_CONSIGNE = ['stats', 'club'];
function lireConsigne(effacer) {
  try {
    const brut = sessionStorage.getItem('equipote:ouvrir');
    if (!brut) return null;
    let page = brut, expire = Infinity;
    try { const o = JSON.parse(brut); if (o && typeof o === 'object') { page = o.page; expire = o.expire; } } catch {}
    if (effacer || Date.now() > expire) sessionStorage.removeItem('equipote:ouvrir');
    return Date.now() <= expire && PAGES_CONSIGNE.includes(page) ? page : null;
  } catch { return null; }
}

export default function App() {
  const [page, setPage]         = useState(() => {
    const q = new URLSearchParams(window.location.search);
    if (q.has('inscription')) {
      // Une personne connectée ne repasse jamais par le formulaire d'essai : on nettoie l'adresse
      if (!isLoggedIn()) return 'inscription';
      try { window.history.replaceState({}, '', window.location.pathname); } catch {}
    }
    // Lien public d'un club : ?equipe=12 ouvre ses statistiques, s'il les a rendues publiques
    const eq = parseInt(q.get('equipe'), 10);
    if (eq && !isLoggedIn()) { setEquipeCourante(eq); return 'stats'; }
    // Un visiteur anonyme arrive sur la connexion : avec plusieurs clubs sur le
    // serveur, l'application ne saurait pas quelles statistiques lui montrer
    if (!isLoggedIn()) return 'login';
    // Consigne d'une seule fois, laissée par « Consulter » dans la console : sans elle,
    // le compte éditeur rouvrirait la console après le rechargement
    const ouvrir = lireConsigne(true);
    if (ouvrir) return ouvrir;
    if (q.has('messages')) { try { window.history.replaceState({}, '', window.location.pathname); } catch {} return 'messages'; }
    if (q.has('taches')) { try { window.history.replaceState({}, '', window.location.pathname); } catch {} return 'taches'; }
    if (q.has('convocations')) { try { window.history.replaceState({}, '', window.location.pathname); } catch {} return 'convocations'; }
    return getCurrentUser()?.role === 'super_admin' ? 'console' : 'stats';
  });
  const [loggedIn, setLoggedIn] = useState(isLoggedIn());
  const [menuOpen, setMenuOpen] = useState(false);
  const [resetToken, setResetToken] = useState(null);
  const [equipes, setEquipes]   = useState([]);
  const [nonLues, setNonLues]   = useState(0);
  const rafraichirNonLues = () => { if (isLoggedIn()) getAnnoncesNonLues().then(r => setNonLues(r.n || 0)).catch(() => {}); };
  useEffect(() => { rafraichirNonLues(); const t = setInterval(rafraichirNonLues, 5 * 60 * 1000); return () => clearInterval(t); }, [page, loggedIn]);
  const [identite, setIdentite] = useState({ club: '', equipe: '' });
  const [logo, setLogo]         = useState(null);
  const [abo, setAbo]           = useState(null);
  const [cond, setCond]         = useState(null);
  const [voirNouveautes, setVoirNouveautes] = useState(false);
  const [voirBientot, setVoirBientot] = useState(false);
  const [voirAide, setVoirAide] = useState(false);
  const [voirVisite, setVoirVisite] = useState(false);
  const [voirSuppression, setVoirSuppression] = useState(false);
  const [prenomVisite, setPrenomVisite] = useState(null);
  // Visite de découverte : une fois les conditions acceptées, si ce compte ne l'a jamais vue
  useEffect(() => {
    if (!loggedIn || cond?.statut !== 'acceptees' || getCurrentUser()?.role === 'super_admin') return;
    getVisite().then(r => { setPrenomVisite(r.prenom || null); if (!r.vue) setVoirVisite(true); }).catch(() => {});
  }, [loggedIn, cond?.statut]);
  const [pastille, setPastille] = useState(false);
  useEffect(() => { setPastille(aDesNouveautes(isLoggedIn() ? getCurrentUser()?.role : null)); }, [loggedIn]);
  // Lien de validation reçu par un parent : il n'a pas besoin d'être connecté
  const [parentToken] = useState(() => new URLSearchParams(window.location.search).get('parent'));
  const [confirmerToken] = useState(() => new URLSearchParams(window.location.search).get('confirmer'));

  // Conditions d'utilisation : vérifiées à la connexion, et de nouveau si le
  // serveur signale en cours de session qu'une nouvelle version est à accepter
  useEffect(() => {
    if (!loggedIn) { setCond(null); return; }
    const verifier = () => getEtatConditions().then(setCond).catch(() => {});
    verifier();
    window.addEventListener('conditions-requises', verifier);
    return () => window.removeEventListener('conditions-requises', verifier);
  }, [loggedIn]);

  // Inscription et confirmation d'essai : pages neutres, aux couleurs d'Équipote,
  // quel que soit le club du visiteur — il est en train d'en ouvrir un autre
  // Pages à la marque d'Équipote : inscription, confirmation, et tout l'écran d'un visiteur
  // non connecté — sauf si l'adresse désigne explicitement un club (lien public ?equipe=…)
  const lienDeClub = new URLSearchParams(window.location.search).has('equipe');
  const pageNeutre = page === 'inscription' || !!confirmerToken || (!loggedIn && !lienDeClub);

  // Titre de l'onglet : le club consulté, puis le produit
  useEffect(() => {
    document.title = pageNeutre ? 'Essai gratuit · Équipote'
                   : identite.club ? `${identite.club} · Équipote` : 'Équipote';
  }, [identite.club, pageNeutre]);

  // Couleurs et logo du club de l'équipe consultée — connecté ou non.
  // Rechargés quand l'admin modifie l'apparence, sans recharger la page.
  useEffect(() => {
    if (pageNeutre) { appliquerTheme(null, null); setLogo(null); return; }
    const charger = () => getEquipePublique().then(e => {
      if (!e || !e.club) return;
      appliquerTheme(e.couleur, e.couleur2);
      setLogo(urlLogo(e.logo_url));
    }).catch(() => {});
    charger();
    window.addEventListener('club-maj', charger);
    return () => window.removeEventListener('club-maj', charger);
  }, [loggedIn, pageNeutre]);
  const user = getCurrentUser();
  const superAdmin = user?.role === 'super_admin';
  const courante = getEquipeCourante();

  // Équipes accessibles et nom du club affiché
  useEffect(() => {
    let annule = false;
    (async () => {
      try {
        if (loggedIn && superAdmin) {
          const liste = await getToutesEquipes();
          if (annule) return;
          // Première connexion : le super admin n'a pas d'équipe par défaut, on prend la première
          if (!liste.some(e => e.id === getEquipeCourante()) && liste.length) {
            setEquipeCourante(liste[0].id);
            window.location.reload();
            return;
          }
          setEquipes(liste);
          const e = liste.find(x => x.id === getEquipeCourante());
          setIdentite(e ? { club: e.club_nom, equipe: e.nom } : { club: 'Équipote', equipe: '' });
        } else if (loggedIn) {
          const club = await getMonClub();
          if (annule) return;
          setAbo(club.abonnement || null);
          const liste = (club.equipes || []).map(e => ({ ...e, club_nom: club.nom }));
          setEquipes(liste);
          let id = getEquipeCourante();
          if (!liste.some(e => e.id === id) && liste.length) { id = liste[0].id; setEquipeCourante(id); }
          const e = liste.find(x => x.id === id);
          setIdentite({ club: club.nom, equipe: liste.length > 1 ? (e?.nom || '') : '' });
        } else {
          // Personne n'est connecté : rien de la session précédente ne doit subsister
          setIdentite({ club: '', equipe: '' }); setEquipes([]);
          const e = await getEquipePublique();
          if (!annule && e?.club) setIdentite({ club: e.club, equipe: '' });
        }
      } catch { /* l'identité reste vide, l'application fonctionne */ }
    })();
    return () => { annule = true; };
  }, [loggedIn, superAdmin]);

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get('reset');
    if (t) setResetToken(t);
  }, []);

  useEffect(() => {
    if (!isLoggedIn() && loggedIn) { setLoggedIn(false); setPage('login'); }
  }, [loggedIn]);

  function handleLogin()  {
    setLoggedIn(true);
    // Un président qui vient d'ouvrir son essai arrive sur « Mon club ». La consigne reste
    // valable quelques minutes : l'acceptation des conditions recharge la page juste après
    setPage(lireConsigne(false) || (getCurrentUser()?.role === 'super_admin' ? 'console' : 'stats'));
  }
  function handleLogout() {
    const sortir = () => { logout(); setLoggedIn(false); setPage('login'); setMenuOpen(false); };
    // Application mobile : d'abord détacher ce téléphone du compte, tant que le jeton est valide
    if (natif) oublierAppareilNatif().finally(sortir); else sortir();
  }
  // Application mobile : toucher une notification ouvre la bonne page (?messages, ?convocations…)
  useEffect(() => { ecouterNotificationsNatives(url => { try { const q = new URL(url).search; if (q) window.location.search = q; } catch {} }); }, []);

  const navItems = [
    { key: 'stats',        label: '📊 Stats',        always: true },
    { key: 'convocations', label: '📩 Mes convocations', role: 'joueur' },
    { key: 'joueurs',      label: '👥 Équipe',        role: 'joueur' },
    { key: 'messages',     label: '📣 Messages',      role: 'joueur' },
    { key: 'taches',       label: '🧾 Tâches',        role: 'joueur' },
    { key: 'presences',    label: '📋 Présences',     role: 'joueur' },
    { key: 'caisse-noire', label: '💰 Caisse Noire',  role: 'joueur' },
    { key: 'caisse-3mt',   label: '🍺 3ème Mi-temps', role: 'joueur' },
    { key: 'admin',        label: '⚙️ Import PDF',     role: 'coach' },
    { key: 'club',         label: '🏛️ Mon club',       role: 'admin_club' },
    { key: 'console',      label: '🛠️ Console',        role: 'super_admin' },
  ];

  const visibleItems = navItems.filter(
    item => item.always || (loggedIn && (!item.role || hasRole(item.role))
      // Caisses désactivées (équipe de jeunes) : masquées pour les joueurs ; le coach garde
      // l'entrée, pour pouvoir les activer
      && !(['caisse-noire', 'caisse-3mt'].includes(item.key) && !hasRole('coach')
           && equipes.find(e => e.id === courante)?.caisses_actives === 0))
  );

  return (
    <div className="app">
      <BandeauMaj />
      <nav className="app-nav">
        <div className="nav-brand" onClick={() => { setPage(loggedIn ? 'stats' : 'login'); setMenuOpen(false); }}>
          {logo
            ? <img src={logo} alt="" style={{ height:28, width:28, objectFit:'contain', borderRadius:6, flexShrink:0 }} />
            : <img src="/img/symbole-equipote.png" alt="" style={{ height:26, width:26, objectFit:'contain', flexShrink:0 }} />}
          <span className="nav-club">{(pageNeutre ? 'Équipote' : identite.club || 'Équipote').toUpperCase()}</span>
          {identite.equipe && !pageNeutre && <span className="nav-sous" style={{ fontSize:11, color:'#8b949e', marginLeft:6, fontWeight:500 }}>
            · {identite.equipe}</span>}
        </div>
        <div className="nav-right">
          {loggedIn && <SelecteurEquipe equipes={equipes} courante={courante} superAdmin={superAdmin} />}
          {loggedIn && user && (
            <span className="nav-role">{user.username} · <b>{({
              super_admin:'éditeur', admin_club:'admin club', admin:'admin club',
              coach:'coach', tresorier:'trésorier', admin_3mt:'trésorier', joueur:'joueur'
            })[user.role] || user.role}</b></span>
          )}
          <button className="menu-btn" onClick={() => setMenuOpen(!menuOpen)} aria-label={nonLues > 0 ? `Menu — ${nonLues} message(s) non lu(s)` : "Menu"}>☰{nonLues > 0 && <span className="pastille-bouton" />}</button>
          {!loggedIn
            ? <button className="conn-btn" onClick={() => { setPage('login'); setMenuOpen(false); }}>Connexion</button>
            : <button className="logout-btn" onClick={handleLogout}>Déco</button>}
        </div>
      </nav>

      {menuOpen && (
        <div className="menu-dropdown">
          {visibleItems.map(item => (
            <button key={item.key}
              className={`menu-item ${page === item.key ? 'active' : ''}`}
              onClick={() => { setPage(item.key); setMenuOpen(false); }}>
              {item.label}
              {item.key === 'messages' && nonLues > 0 && <span className="pastille-menu" aria-label={`${nonLues} non lu(s)`}>{nonLues}</span>}
            </button>
          ))}
        </div>
      )}

      {loggedIn && !parentToken && !pageNeutre && <BandeauAbonnement abo={abo} role={user?.role} />}

      <main className="app-main">
        {confirmerToken ? <InscriptionPage token={confirmerToken} />
         : page === 'inscription' ? <InscriptionPage />
         : parentToken ? <ConditionsPage mode="parent" token={parentToken} />
         : loggedIn && ['suspendu', 'essai_termine'].includes(abo?.statut)
           ? <EcranSuspendu onDeco={handleLogout} essai={abo.statut === 'essai_termine'}
                            admin={['admin_club', 'admin'].includes(user?.role)} />
         : loggedIn && cond && cond.statut !== 'acceptees'
           ? <ConditionsPage mode={cond.statut} etat={cond} onDeco={handleLogout}
                             onAcceptees={() => { setCond({ ...cond, statut:'acceptees' }); window.location.href = window.location.pathname; }} />
         : <>
        {!resetToken && page === 'confidentialite' && <ConditionsPage mode="lecture" onFermer={() => setPage('stats')} />}
        {resetToken && <ResetPasswordPage token={resetToken} onDone={() => {
          setResetToken(null);
          window.history.replaceState({}, '', window.location.pathname);
          setPage('login');
        }} />}
        {!resetToken && page === 'stats'        && <PublicStats />}
        {!resetToken && page === 'login'        && !loggedIn && <LoginPage onLogin={handleLogin} />}
        {!resetToken && page === 'convocations' && loggedIn && <MesConvocationsPage />}
        {!resetToken && page === 'joueurs'      && loggedIn && <JoueursPage />}
        {!resetToken && page === 'messages'     && loggedIn && <MessagesPage onLu={rafraichirNonLues} />}
        {!resetToken && page === 'taches'       && loggedIn && <TachesPage />}
        {!resetToken && page === 'presences'    && loggedIn && <PresencesPage />}
        {!resetToken && page === 'caisse-noire' && loggedIn && <CaissesGarde type="noire"><CaisseNoirePage /></CaissesGarde>}
        {!resetToken && page === 'caisse-3mt'   && loggedIn && <CaissesGarde type="3mt"><Caisse3mtPage /></CaissesGarde>}
        {!resetToken && page === 'admin'        && loggedIn && hasRole('coach') && <AdminPanel />}
        {!resetToken && page === 'club'         && loggedIn && hasRole('admin_club') && <ClubPage />}
        {!resetToken && page === 'console'      && loggedIn && hasRole('super_admin') && <ConsolePage />}
        </>}
      </main>

      <AppliwebFooter onConfidentialite={() => { setPage('confidentialite'); window.scrollTo(0, 0); }}
                      onNouveautes={() => setVoirNouveautes(true)} nouveau={pastille}
                      onBientot={loggedIn ? () => setVoirBientot(true) : null} onAide={() => setVoirAide(true)} />
      {voirBientot && <Bientot onFermer={() => setVoirBientot(false)} />}
      {voirSuppression && <SuppressionCompte onFermer={() => setVoirSuppression(false)}
                            onSupprime={() => { setVoirSuppression(false); handleLogout(); window.alert('Ton compte a été supprimé. Merci d\'avoir utilisé Équipote.'); }} />}
      {voirVisite && (() => { const u = getCurrentUser() || {};
        return <Visite role={u.role} prenom={prenomVisite} club={u.club_nom} equipe={(u.equipes || []).find(e => e.id === getEquipeCourante())?.nom}
                       onFermer={() => setVoirVisite(false)} />; })()}
      {voirAide && <Aide onFermer={() => setVoirAide(false)} connecte={loggedIn} page={page}
                         onRevoirVisite={loggedIn && getCurrentUser()?.role !== 'super_admin' ? () => { setVoirAide(false); setVoirVisite(true); } : null}
                         onSupprimerCompte={loggedIn && getCurrentUser()?.role !== 'super_admin' ? () => { setVoirAide(false); setVoirSuppression(true); } : null}
                         avecClub={loggedIn && !!getCurrentUser()?.club_id && getCurrentUser()?.role !== 'super_admin'} />}
      {voirNouveautes && <Nouveautes role={loggedIn ? user?.role : null}
                                     onFermer={() => { setVoirNouveautes(false); setPastille(false); }} />}
    </div>
  );
}
